import { formatInstant } from '../utils/datetime';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const PRODUCT_TYPE_LABELS: Record<string, string> = {
  secret_lair: 'Secret Lair',
  secret_lair_bundle: 'Bundle',
  'precon:commander': 'Commander',
  'precon:challenger': 'Challenger',
  'precon:event': 'Event',
  'precon:brawl': 'Brawl',
};

export function sealedProductTypeLabel(productType: string | null | undefined): string {
  if (!productType) return 'Sealed';
  return PRODUCT_TYPE_LABELS[productType] ?? productType;
}

/** Calendar dates stay on their printed day. Instants go through formatInstant. */
export function formatSealedReleaseDate(value: string | null | undefined): string {
  if (!value) return '—';
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (match) {
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (month >= 1 && month <= 12 && day >= 1 && day <= 31) {
      return `${MONTHS[month - 1]} ${day}, ${match[1]}`;
    }
  }
  return formatInstant(value);
}

export function formatReportMoney(value: number | null | undefined): string {
  if (value == null || Number.isNaN(Number(value))) return '—';
  return `$${Number(value).toFixed(2)}`;
}

/**
 * Incomplete crack quotes are a badge, never a dollar amount.
 * Non-positive numbers are missing quotes, including a stored zero.
 */
export function formatCrackMoney(
  complete: boolean,
  value: number | null | undefined,
): string | null {
  if (!complete) return null;
  if (value == null || Number.isNaN(Number(value)) || Number(value) <= 0) return null;
  return formatReportMoney(value);
}

export function formatSealedMoney(value: number | null | undefined): string {
  if (value == null || Number.isNaN(Number(value)) || Number(value) <= 0) return '—';
  return formatReportMoney(value);
}

export function formatLineMoney(value: number | null | undefined): string {
  if (value == null || Number.isNaN(Number(value)) || Number(value) <= 0) return '—';
  return formatReportMoney(value);
}

export function finishLabel(finish: string | null | undefined): string {
  if (finish === 'foil') return 'Foil';
  if (finish === 'normal' || finish === 'nonfoil') return 'Nonfoil';
  return finish || '—';
}

export function feePercent(rate: number): string {
  return `${(rate * 100).toFixed(2)}%`;
}
